import FeedbackContainer from "../../Component/Feedback/Feedback"

const Feedback = () => {
  return (
    <div className='page-body'>
      <FeedbackContainer />
    </div>
  )
}

export default Feedback